import authApiService from "./userApiService"; // axios instance with interceptors

export const employeeManagementService = {
  // Existing routes...

  // Test route
  async testConnection() {
    try {
      const response = await authApiService.get("/employees/test");
      return { success: true, data: response.data };
    } catch (error) {
      return handleError(error);
    }
  },

  // Add new employee
  async addEmployee(employeeData) {
    try {
      const response = await authApiService.post("/employees", {
        name: employeeData.name,
        role: employeeData.roles
      });
      return { success: true, data: response.data };
    } catch (error) {
      return handleError(error);
    }
  },

  // Update employee by ID
  async updateEmployee(id, employeeData) {
    try {
      const response = await authApiService.put(`/employees/${id}`, {
        name: employeeData.name,
        role: employeeData.role
      });
      return { success: true, data: response.data };
    } catch (error) {
      return handleError(error);
    }
  },

  // Delete employee by ID
  async deleteEmployee(id) {
    try {
      const response = await authApiService.delete(`/employees/${id}`);
      return { success: true, data: response.data };
    } catch (error) {
      return handleError(error);
    }
  },

  // Get single employee by ID
  async getSingleEmployee(employeeId) {
    try {
      const response = await authApiService.get(`/employees/${employeeId}`);
      return { success: true, data: response.data };
    } catch (error) {
      return handleError(error);
    }
  },

  // Get all employees with optional filtering and pagination
  async getAllEmployees(params = {}) {
    try {
      const queryParams = {
        page: params.page || 1,
        limit: params.limit || 10,
        ...params
      };

      Object.keys(queryParams).forEach(key => {
        if (queryParams[key] === undefined || queryParams[key] === null || queryParams[key] === '') {
          delete queryParams[key];
        }
      });

      const response = await authApiService.get("/employees", { params: queryParams });
      return { success: true, data: response.data };
    } catch (error) {
      return handleError(error);
    }
  },

  // Get all employee names
  async getAllEmployeeNames() {
    try {
      const response = await authApiService.get("/employees/names/all");
      return { success: true, data: response.data };
    } catch (error) {
      return handleError(error);
    }
  },

  // Get employees by specific role
  async getEmployeesByRole(role) {
    try {
      const response = await authApiService.get(`/employees/role/${role}`);
      return { success: true, data: response.data };
    } catch (error) {
      return handleError(error);
    }
  },

  // Get employee names for specific role
  async getEmployeeNamesByRole(role) {
    try {
      const response = await authApiService.get(`/employees/names/role/${role}`);
      return { success: true, data: response.data };
    } catch (error) {
      return handleError(error);
    }
  },

  // Get all roles
  async getAllRoles() {
    try {
      const response = await authApiService.get("/employees/rolesnew");
      return { success: true, data: response.data };
    } catch (error) {
      return handleError(error);
    }
  },

  // Employee data aggregation routes
  async getAllEmpData(params) {
    try {
      const response = await authApiService.get('/employees/data/all', { params });
      return { success: true, data: response.data };
    } catch (error) {
      return handleError(error);
    }
  },

  async getAllEmpDataTax() {
    try {
      const response = await authApiService.get("/employees/data/tax");
      return { success: true, data: response.data };
    } catch (error) {
      return handleError(error);
    }
  },

  async getAllEmpDataTip() {
    try {
      const response = await authApiService.get("/employees/data/tip");
      return { success: true, data: response.data };
    } catch (error) {
      return handleError(error);
    }
  },

  // Get employee role by name
  async getRoleFromEmpName(name) {
    try {
      const response = await authApiService.get(`/employees/role-lookup/${encodeURIComponent(name)}`);
      return { success: true, data: response.data };
    } catch (error) {
      return handleError(error);
    }
  },

  // Financial / Expense routes
  async getTotalExpensesCleaningCrew() {
    try {
      const response = await authApiService.get("/employees/expenses/cleaning-crew");
      return { success: true, data: response.data };
    } catch (error) {
      return handleError(error);
    }
  },

  async getTotalExpensesStoreRun() {
    try {
      const response = await authApiService.get("/employees/expenses/store-run");
      return { success: true, data: response.data };
    } catch (error) {
      return handleError(error);
    }
  },

  async getExpenses() {
    try {
      const response = await authApiService.get("/employees/expenses/total");
      return { success: true, data: response.data };
    } catch (error) {
      return handleError(error);
    }
  },

  async getDeposit() {
    try {
      const response = await authApiService.get("/employees/deposits/total");
      return { success: true, data: response.data };
    } catch (error) {
      return handleError(error);
    }
  },

  async getExpensesPromos() {
    try {
      const response = await authApiService.get("/employees/expenses/promos");
      return { success: true, data: response.data };
    } catch (error) {
      return handleError(error);
    }
  },

  async getDepositPromos() {
    try {
      const response = await authApiService.get("/employees/deposits/promos");
      return { success: true, data: response.data };
    } catch (error) {
      return handleError(error);
    }
  },

 // Get complete employee data with all history and related information
 async getCompleteEmployeeData(employeeId, params = {}) {
  try {
    const response = await authApiService.get(`/employees/${employeeId}/complete-data`, {
      params: {
        startDate: params.startDate,
        endDate: params.endDate
      }
    });
    return { success: true, data: response.data };
  } catch (error) {
    return handleError(error);
  }
},

async getEmployeePerformanceMetrics(employeeId, params = {}) {
  try {
    const response = await authApiService.get(`/employees/${employeeId}/performance-metrics`, {
      params: {
        startDate: params.startDate,
        endDate: params.endDate
      }
    }); return { success: true, data: response.data };
  } catch (error) {
    return handleError(error);
  }
},
};

// Error handler
function handleError(error) {
  console.error("Employee API Error:", error);
  
  let message = "Something went wrong";
  let status = 500;

  if (error.response) {
    status = error.response.status;
    message = error.response.data?.message || 
              error.response.data?.error || 
              `HTTP ${status} Error`;
  } else if (error.request) {
    message = "Network error. Please check your connection.";
    status = 0;
  } else {
    message = error.message || "An unexpected error occurred";
  }

  return { 
    success: false, 
    message, 
    status,
    originalError: error
  };
}
